import React from 'react';

interface CheckIconProps {
  fill?: string;
  width?: number;
  height?: number;
}

const CheckIcon: React.FC<CheckIconProps> = ({ fill = '#1C2DEF', width = 24, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.7093 6.29196C19.8024 6.38485 19.8763 6.4952 19.9267 6.61669C19.9771 6.73818 20.003 6.86842 20.003 6.99996C20.003 7.13149 19.9771 7.26173 19.9267 7.38322C19.8763 7.50471 19.8024 7.61507 19.7093 7.70796L10.7093 16.708C10.6164 16.8011 10.506 16.875 10.3845 16.9254C10.263 16.9758 10.1328 17.0017 10.0013 17.0017C9.86973 17.0017 9.73949 16.9758 9.618 16.9254C9.49651 16.875 9.38615 16.8011 9.29326 16.708L5.29326 12.708C5.10549 12.5202 5 12.2655 5 12C5 11.7344 5.10549 11.4797 5.29326 11.292C5.48104 11.1042 5.73571 10.9987 6.00126 10.9987C6.26681 10.9987 6.52149 11.1042 6.70926 11.292L10.0013 14.586L18.2933 6.29196C18.3862 6.19883 18.4965 6.12494 18.618 6.07453C18.7395 6.02412 18.8697 5.99817 19.0013 5.99817C19.1328 5.99817 19.263 6.02412 19.3845 6.07453C19.506 6.12494 19.6164 6.19883 19.7093 6.29196Z"
      fill={fill}
    />
  </svg>
);

export default CheckIcon;
